import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { EsFileState } from '@enums';
import { useCourtFiles } from '../court-files';
import { useColumns } from './court-file-registry-columns';

export const COURT_FILES_REGISTRY_IDENTIFIER = 'COURT_FILES_REGISTRY';
export const COURT_FILES_REGISTRY_VERSION = 13;

export function CourtFilesRegistry() {
  const intl = useIntl();
  const columns = useColumns();

  const { evidenceBag } = useCourtFiles({
    evidenceProps: {
      identifier: COURT_FILES_REGISTRY_IDENTIFIER,
      version: COURT_FILES_REGISTRY_VERSION,
      tableProps: {
        columns,
        defaultPreFilters: [
          {
            field: 'state.id',
            operation: ApiFilterOperation.EQ,
            value: EsFileState.REGISTRY,
          },
        ],
        tableName: intl.formatMessage({
          id: 'ES__COURT_FILES_REGISTRY__TABLE__TITLE',
          defaultMessage: 'Soudní spisy - Spisovna',
        }),
      },
      detailProps: {
        toolbarProps: {
          showBtn: (btn) => !['NEW'].includes(btn),
          disableBtn: (btn: string) => !['SHARE', 'REFRESH'].includes(btn),
        },
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
